var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFantomeProduitsChimiques(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 963.98 872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}.cls-2{fill:#ffd93b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fantome produits chimiques") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_8",
    "data-name": "Calque 8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1437.45,1377H520.25c-17.52,0-28.53-19.42-19.88-35.08l455.09-824a22.56,22.56,0,0,1,39.69-.14l462.1,824C1466,1357.45,1455,1377,1437.45,1377Z",
    transform: "translate(-496.86 -505.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1346.57,1316.5H603.13c-14.2,0-23.13-15.74-16.12-28.43L955.89,620.14a18.29,18.29,0,0,1,32.17-.11L1362.63,1288C1369.74,1300.65,1360.83,1316.5,1346.57,1316.5Z",
    transform: "translate(-496.86 -505.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879,1182l-45-46v-29c.79-8.64,5.12-14,11-18l30-12,71,54Z",
    transform: "translate(-496.86 -505.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888,1072l49-18,3-24c-46-59-36.53-145.38,35-153,72,6,85,92,38,157v21l54,17-70,36-22-94-14,90Z",
    transform: "translate(-496.86 -505.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083,1078l24,8c11.5,5.34,20.15,12.9,20,25v30l-49,44-68-51Z",
    transform: "translate(-496.86 -505.5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.14 769.5 489.14 652.5 575.14 684.5 483.14 769.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.14 769.5 390.14 684.5 472.14 650.5 474.14 769.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFantomeProduitsChimiques);
export default __webpack_public_path__ + "static/media/fantome_produits_chimiques.e40bfee6446b04da14b8c287773eaf46.svg";
export { ForwardRef as ReactComponent };